module.exports = __webpack_public_path__ + "img/run3.6d0aaaca.png";